import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useHttpHook from "../../Hooks/HttpHook";
import { getMerchBaseUrl } from "../../utils/apiBase";
import { exchangeEventSsoToken } from "../../utils/eventSsoLogin";
import {
  isAuthRoutePath,
  pathWithoutSsoToken,
  readSsoQueryToken,
} from "../../utils/ssoQueryToken";
import BootLoader from "./BootLoader";

const loginHomeUrl = () => `${getMerchBaseUrl()}/login?platform=event`;

/** ?token= on current route → same login as /Auth/:token, stay on same path. */
function SsoQueryTokenLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [, sendRequest] = useHttpHook();
  const isUserAuthed = useSelector((state) => Boolean(state.user?.token));
  const startedRef = useRef(null);

  const ssoToken = readSsoQueryToken(location.search);
  const onAuthRoute = isAuthRoutePath(location.pathname);
  const showLoader = Boolean(ssoToken) && !onAuthRoute && !isUserAuthed;

  useEffect(() => {
    if (onAuthRoute) return;

    const stayOnPath = pathWithoutSsoToken(
      location.pathname,
      location.search
    );

    if (isUserAuthed && ssoToken) {
      navigate(stayOnPath, { replace: true });
      return;
    }

    if (!ssoToken) {
      startedRef.current = null;
      return;
    }

    if (startedRef.current === ssoToken) return;
    startedRef.current = ssoToken;

    (async () => {
      try {
        const result = await exchangeEventSsoToken(
          sendRequest,
          dispatch,
          ssoToken
        );
        if (result.ok) {
          navigate(stayOnPath, { replace: true });
          return;
        }
      } catch (err) {
        console.log({ err });
      }
      startedRef.current = null;
      window.location.href = loginHomeUrl();
    })();
  }, [
    dispatch,
    isUserAuthed,
    location.pathname,
    location.search,
    navigate,
    onAuthRoute,
    sendRequest,
    ssoToken,
  ]);

  if (!showLoader) return null;

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 10000 }} aria-busy="true">
      <BootLoader />
    </div>
  );
}

export default SsoQueryTokenLogin;
